import { gql, useQuery } from "@apollo/client";
import { ErrorComponent } from "@src/components";
import Summary from "@src/components/summary/Summary";
import { type GQLCameraSummaryAdminQuery, type GQLCameraSummaryAdminQueryVariables } from "@src/graphql.generated";
import Calendar from "@src/icons/Calendar";
import CameraActive from "@src/icons/CameraActive";
import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

const cameraSummaryAdminQuery = gql`
    query CameraSummaryAdmin {
        cameraSummaryAdmin {
            activeSimsCount
            activatedCamerasCount
            licenceWillExpireCount
        }
    }
`;

const CamerasSummary: FC<PropsWithChildren> = () => {
    const { data, error } = useQuery<GQLCameraSummaryAdminQuery, GQLCameraSummaryAdminQueryVariables>(cameraSummaryAdminQuery);

    const summaryItems = [
        {
            count: data?.cameraSummaryAdmin.activeSimsCount,
            text: <FormattedMessage id="reviermanager.page.devices.summary.sim" defaultMessage="Aktive Kameras" />,
            icon: <CameraActive fontSize="large" color="primary" />,
        },
        {
            count: data?.cameraSummaryAdmin.activatedCamerasCount,
            text: <FormattedMessage id="reviermanager.page.devices.summary.camera" defaultMessage="Aktivierte Kameras" />,
            icon: <CameraActive fontSize="large" color="primary" />,
        },
        {
            count: data?.cameraSummaryAdmin.licenceWillExpireCount,
            text: <FormattedMessage id="reviermanager.page.devices.summary.licence" defaultMessage="auslaufende Lizenzen nächsten 30 Tage" />,
            icon: <Calendar fontSize="large" color="primary" />,
        },
    ];

    if (error) {
        return <ErrorComponent />;
    }

    return <Summary items={summaryItems} />;
};

export default CamerasSummary;
